import { IconButton, InputAdornment } from '@material-ui/core';
import React from 'react';
var InputIconWrapper = function (_a) {
    var icon = _a.icon, action = _a.action;
    if (action) {
        return React.createElement(IconButton, { onClick: action }, icon);
    }
    return React.createElement("div", { style: { margin: '0 10px' } }, icon);
};
export var buildInputIcon = function (_a) {
    var _b;
    var _c = _a.position, position = _c === void 0 ? 'end' : _c, icon = _a.icon, action = _a.action;
    return _b = {},
        _b[position + "Adornment"] = (React.createElement(InputAdornment, { position: position },
            React.createElement(InputIconWrapper, { action: action, icon: icon }))),
        _b;
};
